import { render, staticRenderFns } from "./customSlider.vue?vue&type=template&id=3616f280&scoped=true"
import script from "./customSlider.vue?vue&type=script&lang=js"
export * from "./customSlider.vue?vue&type=script&lang=js"
import style0 from "./customSlider.vue?vue&type=style&index=0&id=3616f280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3616f280",
  null
  
)

export default component.exports